import React from 'react';
import { useTranslation } from 'react-i18next';

import { INTL_LOCALES, SupportedLocale } from '@/lib/i18n/settings';

export interface INumberFormatProps {
  children: number;
  prefix?: string;
  accuracy?: number;
}

const NumberFormat = (props: INumberFormatProps) => {
  const { i18n } = useTranslation();
  const intlLocale = INTL_LOCALES[i18n.language as SupportedLocale] || 'en-US';
  const result = new Intl.NumberFormat(intlLocale, {
    maximumSignificantDigits: props.accuracy || 2,
  }).format(props.children);
  return (
    <span>{props.prefix ? <span dangerouslySetInnerHTML={{ __html: `${props.prefix} ${result}` }} /> : result}</span>
  );
};

export default NumberFormat;
